import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useActions } from '../../store'
import { useErrorHandler } from '../useErrorHandler'
import { useResponseHandler } from '../useResponseHandler'
import { useAuth } from '../'

const { env } = window

const useDeleteTenantMutation = () => {
  const { securedFetch } = useAuth()
  const { handleError } = useErrorHandler()
  const { handleResponse } = useResponseHandler()
  const { setMessage, progressStart, progressEnd } = useActions()
  const queryClient = useQueryClient()

  const deleteTenant = async (id) => {
    const url = encodeURI(`${env.apiUrl}/tenants/${id}`)
    const response = await securedFetch(url, { method: 'DELETE' })
    await handleResponse(response)
  }

  return useMutation({
    mutationFn: ({ id }) => deleteTenant(id),
    onMutate: progressStart,
    onError: (error) => handleError(error, 'Error deleting group'),
    onSuccess: () => {
      setMessage('This project has been deleted')
      queryClient.invalidateQueries({ queryKey: ['tenants'] })
    },
    onSettled: progressEnd
  })
}

export { useDeleteTenantMutation }
